import { render, staticRenderFns } from "./LaborProtectionAccidentCard.vue?vue&type=template&id=2fc1c1ff&"
import script from "./LaborProtectionAccidentCard.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionAccidentCard.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionAccidentCard.vue?vue&type=style&index=0&id=2fc1c1ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports